import { FormBuilder, Validators } from '@angular/forms';
import { AvpCustomAdaptor } from './../../../base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ServicesAdministrationService } from './services-administration.service';
import { Component, OnInit } from '@angular/core';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { StatusServiceDTO, ServiceStatusLevel } from 'src/app/base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ServiceEditFormType } from './service-edit-form/service-edit-form';

import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';
import { ServiceEditFormComponent } from './service-edit-form/service-edit-form.component';

@Component({
  selector: 'app-services-administration',
  templateUrl: './services-administration.component.html',
  styleUrls: ['./services-administration.component.scss'],
  imports: [SearchFieldComponent, GridModule, ToolbarModule, ServiceEditFormComponent, TranslateModule],
  providers: [ServicesAdministrationService]
})
export class ServicesAdministrationComponent extends GridBaseComponent<ServiceEditFormType> implements OnInit {

  constructor(
    private servicesAdministrationService: ServicesAdministrationService,
    private fb: FormBuilder,
    translateService: TranslateService,
    private spinnerService: SpinnerService
  ) {
    super(null, translateService, servicesAdministrationService);
    this.searchOptions = { fields: ['name', 'description'] };
  }

  public ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.servicesAdministrationService, this.spinnerService),
    });
    this.editDialogTitle = 'i18n.domain.services.overview.edit-dialog-title';
    this.addDialogTitle = 'i18n.domain.services.overview.add';
  }

  public formatStatus(data: any): string {
    switch (data?.effectiveStatus) {
      case ServiceStatusLevel.Operational:
        return this.translateService.instant('i18n.domain.status.levels.operational');
      case ServiceStatusLevel.Degraded:
        return this.translateService.instant('i18n.domain.status.levels.degraded');
      case ServiceStatusLevel.Down:
        return this.translateService.instant('i18n.domain.status.levels.down');
      default:
        return '';
    }
  }

  public formatBaseStatus(data: any): string {
    switch (data?.baseStatus) {
      case ServiceStatusLevel.Operational:
        return this.translateService.instant('i18n.domain.status.levels.operational');
      case ServiceStatusLevel.Degraded:
        return this.translateService.instant('i18n.domain.status.levels.degraded');
      case ServiceStatusLevel.Down:
        return this.translateService.instant('i18n.domain.status.levels.down');
      default:
        return '';
    }
  }

  protected override addObjectCompare(addedObject: StatusServiceDTO, rowObject: StatusServiceDTO): boolean {
    if (this.addIndexFindColumnName) {
      return addedObject.name === rowObject.name;
    }
    return false;
  }

  protected initializeEditForm(data: any): void {
    this.gridEditForm = this.fb.group<ServiceEditFormType>({
      id: this.fb.control<number>(data.id),
      name: this.fb.control<string>(data.name, Validators.required),
      description: this.fb.control<string>(data.description),
      baseStatus: this.fb.control<number>(data.baseStatus ?? ServiceStatusLevel.Operational),
    });
  }

  protected getEditDialogTitleParams(rowData: any): object {
    return { param: rowData.name };
  }
}
